import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import { axiosAuth_SECURITY_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const DatakeyAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
     keySize: 256
  });


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (   objAttrs.metadata
               && (objAttrs.metadata !== '')
               && (!testJSON(objAttrs.metadata.trim()))) {
      setErrMsg(t("I18N_ERR_Metadata_need_valid_JSON"));
      return;
    }

    // Make a deep copy
    let reqBody = JSON.parse(JSON.stringify(objAttrs));

    if ((objAttrs.metadata == null) || (objAttrs.metadata === '')) {
      reqBody.metadata = null;
    } else {
      reqBody.metadata = JSON.parse(objAttrs.metadata.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_SECURITY_API.post("data-keys", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Datakey")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Datakey_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Description")}: *</Col>
              <Col md={3}>{t("I18N_Key_size")} *</Col>
              <Col md={6}>{t("I18N_Metadata")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={objAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="keySize" value={objAttrs.keySize}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={6}>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} rows={5} name="metadata" value={objAttrs.metadata}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

{/*
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Permissions")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} rows={23} name="keyPermissions" value={objAttrs.keyPermissions}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>
*/}

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </Form>
        </Container>

      </Card>
    </>
  );
}

export default DatakeyAdminNewView;
